export default {
  title: 'Booking payments',
  close: 'Close',
  description: 'Below is the payment distribution between all participants.'
}